import React from 'react'

const Notice = (props) => {

    const notice = props.notice
    return (
        <div className={`notice notice-${notice.type} msync-notice`}>
            {notice.message}
        </div>
    )
}

export default Notice